
import { supabase } from "../integrations/supabase/client";
import { ChargingStation } from "../types/task";

export const subscribeToStationUpdates = (
  onUpdate: (updatedStation: ChargingStation) => void
) => {
  const channel = supabase
    .channel('stations-updates')
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'stations'
      },
      (payload: any) => {
        if (payload.eventType === 'UPDATE') {
          const updatedStation = payload.new as ChargingStation;
          onUpdate(updatedStation);
        }
      }
    )
    .subscribe();

  return () => {
    supabase.removeChannel(channel);
  };
};
